import { VNode } from "preact";

declare const IS_SERVER: boolean;

export type Page = {
	title: string;
	component: () => Promise<VNode>;
};

const loadMarkdownPage = async (
	loadMarkdown: () => Promise<{ default: string }>
) => {
	const { PageLayout } = await import("./components/page-layout");
	const { Markdown } = await import("./components/markdown");
	const content = await loadMarkdown();
	return (
		<PageLayout>
			<Markdown>{content.default}</Markdown>
		</PageLayout>
	);
};

export const pages = {
	sandbox: {
		title: "Code sandbox",
		component: async () => {
			if (IS_SERVER) {
				return <></>;
			}
			await import("./pages/sandbox/sandbox");
			return <></>;
		},
	},

	not_found: {
		title: "Page Not Found",
		component: async () => {
			const { PageNotFound } = await import("./pages/page-not-found");
			return <PageNotFound />;
		},
	},

	index: {
		title: "Fluid State - Simple, Powerful, Reactive State Management",
		component: () => loadMarkdownPage(() => import("./pages/docs/index.md")),
	},

	integrations_react: {
		title: "Fluid State React - Reactive State Management For React",
		component: () =>
			loadMarkdownPage(() => import("./pages/docs/integrations_react.md")),
	},

	integrations_preact: {
		title: "Fluid State Preact - Reactive State Management For Preact",
		component: () =>
			loadMarkdownPage(() => import("./pages/docs/integrations_preact.md")),
	},

	layers_alien: {
		title: "Fluid State Alien - Alien Signals-based Reactive Layer",
		component: () =>
			loadMarkdownPage(() => import("./pages/docs/layers_alien.md")),
	},

	layers_mobx: {
		title: "Fluid State MobX - MobX-based Reactive Layer",
		component: () =>
			loadMarkdownPage(() => import("./pages/docs/layers_mobx.md")),
	},

	layers_preact: {
		title: "Fluid State Preact - Preact Signals-based Reactive Layer",
		component: () =>
			loadMarkdownPage(() => import("./pages/docs/layers_preact.md")),
	},

	license: {
		title: "Fluid State - license",
		component: () => loadMarkdownPage(() => import("./pages/docs/license.md")),
	},
} as const;

export type PageName = keyof typeof pages;
